import { FormExtractorService } from "../../../shared/services/form-extractor.service";
import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_203 implements Validator {

    public static id = 'CTRL_203';
    private message = 'error.ctr_203';

    public LOG: LogService = new LogService(CTRL_203);
    public formExtractorService: FormExtractorService = new FormExtractorService();
    
    validate(form: any, map) {
        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_203.id + '_');

        if (rgs.length > 0) {
            const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const firstNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const secondNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const thirdNameWithStepId = map.get(ctrl.value.rgCtrls.thirdChamp);
                const fourthNameWithStepId = map.get(ctrl.value.rgCtrls.fourthChamp);
                const firstCtrl = form.controls[firstNameWithStepId];
                const secondCtrl = form.controls[secondNameWithStepId];
                const thirdCtrl = form.controls[thirdNameWithStepId];
                const fourthCtrl = form.controls[fourthNameWithStepId];

                if (!this.isEmptyOrNullOrUndefined(firstCtrl.value) && (this.isEmptyOrNullOrUndefined(secondCtrl.value) || this.isEmptyOrNullOrUndefined(thirdCtrl.value) || this.isEmptyOrNullOrUndefined(fourthCtrl.value))) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }

    isEmptyOrNullOrUndefined(value): boolean{
		return (value === undefined || value === null || value === '');
	}
}